import React, { useEffect, useState } from 'react';
import CaretCircleRight from '@components/Icons/CaretCircleRight';
import Link from '@components/CustomLink';
import Button from '@components/Buttons';
import s from './Container.module.scss';
import Card from '../Card';
import type { CardProps } from '../Card/Card';

type ContainerProps = {
  data: Omit<CardProps, 'inContainer'>[];
  title?: string | null;
  link?: string | null;
  chunk?: number;
  subTitle?: string;
  isList?: boolean;
};

const Container = ({ data, title, subTitle, link, isList, chunk = 3 }: ContainerProps): JSX.Element => {
  const [howMany, setHowMany] = useState(chunk);

  useEffect(() => {
    setHowMany(chunk);
  }, [chunk]);

  if (!data.length) {
    return <></>;
  }

  return (
    <section className={isList ? s.wrapperList : s.wrapper}>
      {!!link && (
        <Link to={link} prefetch={false}>
          <header>
            <div>
              <h2 className="caps">{title ?? ''}</h2>
              {subTitle && <small className="caption">{subTitle}</small>}
            </div>
            <CaretCircleRight weight="fill" />
          </header>
        </Link>
      )}
      {!link && !isList && (
        <header>
          <div>
            <h2 className="body-md-bold">{title}</h2>
            {subTitle && <small className="caption">{subTitle}</small>}
          </div>
        </header>
      )}

      {data.slice(0, howMany)?.map((item, index) => <Card {...item} key={index} inContainer={!isList} />)}
      {data?.length > howMany && (
        <Button isSecondary isFullWidth onClick={() => setHowMany(howMany + chunk)} className={s.button}>
          Load more
        </Button>
      )}
    </section>
  );
};

export default Container;
